import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { Kpi, MonthlyChart, ExportButtons, Q } from "./shared";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export const OverviewTab = ({ params }) => {
  const [d, setD] = useState(null);
  useEffect(() => {
    let live = true;
    setD(null);
    api.get("/analytics/overview", { params }).then((r) => { if (live) setD(r.data); }).catch((e) => live && toast.error(formatApiError(e.response?.data?.detail)));
    return () => { live = false; };
  }, [params]);
  if (!d) return <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>;
  const k = d.kpis;
  return (
    <div className="space-y-4" data-testid="analytics-overview">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <Kpi label="Ventas" value={Q(k.venta)} sub={`${k.docs} documentos · ticket ${Q(k.ticket)}`} testid="kpi-venta" />
        <Kpi label="Costo de ventas" value={Q(k.costo)} sub={k.uncosted ? `${k.uncosted} factura(s) sin costear` : "Todo costeado"} testid="kpi-costo" />
        <Kpi label="Utilidad bruta" value={Q(k.utilidad)} sub={`Margen ${k.margen}%`} tone="text-green-600" testid="kpi-utilidad" />
        <Kpi label="Clientes activos" value={k.clients} sub={`Por cobrar hoy ${Q(k.receivables)}`} tone="text-blue-600" testid="kpi-clientes" />
      </div>
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-bold uppercase tracking-widest text-muted-foreground">Ventas, costo y utilidad — últimos 12 meses</h3>
        <ExportButtons tab="overview" params={params} />
      </div>
      <MonthlyChart data={d.monthly} testid="overview-chart" />
    </div>
  );
};
